(() => {
'use strict';
if(customElements.get('prink-free-shipping-offer'))return;
const instances=new Set();
class FreeShippingOffer extends HTMLElement{
connectedCallback(){
 this.querySelector('button').dataset.pwRecPlacement=this.closest('cart-drawer')?'cart_drawer':'cart_page';
 this.config=JSON.parse(this.querySelector('[data-offer-config]').textContent);this.render();
 instances.add(this);
 this.querySelector('button').addEventListener('click',()=>this.add());
}
disconnectedCallback(){instances.delete(this);}
render(){
 const c=this.config,l=c.labels;
 const zone=document.documentElement.dataset.pwDeliveryZone||(this.dataset.country==='ES'?'peninsula':this.dataset.country.toLowerCase());
 this.hidden=true;const quote=window.PrinkFreeShippingMath.quote(c,zone,Date.now());if(!quote)return;
 const shipping=quote.shipping;
 this.offer=quote.offer;const offer=this.offer,money=n=>new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:'EUR'}).format(n/100);
 const reserve=offer.items.some(item=>item.reserve);this.querySelector('h3').textContent=reserve?l.black_heading:l.simple_heading;const hook=this.querySelector('.pw-free-offer__hook');hook.hidden=!offer.promoPossible;hook.textContent=offer.promoPossible?l.promo_hook:'';
 const list=this.querySelector('ul');list.replaceChildren();
 offer.items.forEach(item=>{
  const li=document.createElement('li'),link=document.createElement('a'),content=document.createElement('div'),price=document.createElement('strong');
  if(item.image){const photo=document.createElement('img');photo.src=item.image;photo.alt='';photo.width=72;photo.height=72;photo.loading='lazy';li.append(photo);}
  link.href=item.url;link.textContent=item.title;price.textContent=money(item.price);content.append(link,price);li.append(content);list.append(li);
 });
 this.hidden=false;
}
async add(){
 if(this.busy||!this.offer)return;
 this.busy=true;const button=this.querySelector('button'),status=this.querySelector('[role="status"]'),l=this.config.labels;button.disabled=true;status.textContent=l.adding;
 const drawer=this.closest('cart-drawer'),onCart=!drawer;
 const rec=window.PrinkRecommendations,recContext=rec?.context('free_shipping',this.dataset.family,onCart?'cart_page':'cart_drawer');
 try{
  const items=this.offer.items.map(item=>({id:item.id,quantity:1}));
  const body={items};
  if(drawer){body.sections=drawer.getSectionsToRender().map(s=>s.id);body.sections_url=window.location.pathname;}
  const options={method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)};
  const response=await (rec?rec.fetchAdd(window.routes.cart_add_url,options,recContext,items):fetch(window.routes.cart_add_url,options));
  const data=await response.json();
  if(!response.ok||data.status)throw Error(l.error);
  if(onCart){window.location.reload();return;}
  drawer.renderContents(data);
  if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'prink-free-shipping',cartData:data});
 }catch(error){
  rec?.emit('error',recContext);
  status.textContent=l.error;
  // Do not retry automatically: stock changes can partially add a multi-item request.
  button.disabled=false;this.busy=false;
  if(drawer){
   try{const url=new URL(window.location.href);url.searchParams.set('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));const response=await fetch(url,{headers:{Accept:'application/json'}});if(response.ok){drawer.renderContents({sections:await response.json()});drawer.querySelector('prink-free-shipping-offer [role="status"]')?.append(l.error);}}catch(_){}
  }
 }
}
}
customElements.define('prink-free-shipping-offer',FreeShippingOffer);
document.addEventListener('pw:delivery-zone',()=>instances.forEach(element=>element.render()));
document.addEventListener('DOMContentLoaded',()=>instances.forEach(element=>element.render()));
window.addEventListener('pageshow',()=>instances.forEach(element=>element.render()));
})();
